import { Component } from '@angular/core';

@Component({
  selector: 'app-certificates',
  templateUrl: './certificates.component.html',
  styleUrls: ['./certificates.component.css'],
})
export class CertificatesComponent {
  displayCustom: boolean = false;

  activeIndex: number = 0;
  cvTempletes = [
    '../../../../../assets/img/certificates/1.jpg',
    '../../../../../assets/img/certificates/2.jpg',

    '../../../../../assets/img/certificates/4.jpg',
    '../../../../../assets/img/certificates/5.jpg',
    '../../../../../assets/img/certificates/6.jpg',
    '../../../../../assets/img/certificates/7.jpg',
    '../../../../../assets/img/certificates/9.jpg',
    '../../../../../assets/img/certificates/3.jpg',
    '../../../../../assets/img/certificates/8.jpg',
    '../../../../../assets/img/certificates/10.jpg',
  ];

  imageClick(index: number) {    
    this.activeIndex = index;
    this.displayCustom = true;
  }
  responsiveOptions = [
    {
      breakpoint: '1199px',
      numVisible: 4,
      numScroll: 1,
    },
    {
      breakpoint: '991px',
      numVisible: 3,
      numScroll: 1,
    },
    {
      breakpoint: '767px',
      numVisible: 2,
      numScroll: 1,
    },
    {
      breakpoint: '560px',
      numVisible: 1,
      numScroll: 1,
    },
  ];
}
